<template>
  <div class="container">
    <div>
      <img src="/static/fx-banner.png" style="width: 100%;">
    </div>
    <div class="tab-banner">
      <div class="banner-item" @click="goto('circleMaiList')">
        <img src="/static/cd-1.png">
        <div class="banner-label">"卖"队友</div>
      </div>
      <div class="banner-item" @click="goto('circleBBList')">
        <img src="/static/cd-2.png">
        <div class="banner-label">表白墙</div>
      </div>
      <div class="banner-item" @click="goto('circleJiyuList')">
        <img src="/static/cd-3.png">
        <div class="banner-label">留言板</div>
      </div>
    </div>
    <div class="mai-container">
      <block-title title="最新被卖" link="circleMaiList" :token="encodeToken"></block-title>
      <div class="mai-top" @click="goto('circleMaiList')">
        <div class="mai-block">
          <div class="block-item">
            <img src="/static/nan.png">
            <div class="block-label">被卖男丁 ({{sfTongji.nanSum}})</div>
          </div>
        </div>
        <div class="vs">
          <img src="/static/vs.png">
        </div>
        <div class="mai-block">
          <div class="block-item">
            <img src="/static/nv.png">
            <div class="block-label">被卖女票 ({{sfTongji.nvSum}})</div>
          </div>
        </div>
      </div>
      <div class="mai-footer" @click="goto('circleMaiList')">
        <div class="nan-line" :style="'width: '+sfNanLineWidth"></div>
        <div class="nv-line" :style="'width: '+sfNvLineWidth"></div>
      </div>

      <mai-item :item="sf" :openid="openid" v-if="sf && sf._id"></mai-item>
    </div>
    <div class="bb-container">
      <block-title title="最新表白" link="circleBBList" :token="encodeToken"></block-title>
      <div class="mai-top" @click="goto('circleBBList')">
        <div class="mai-block">
          <div class="block-item">
            <img src="/static/nan.png">
            <div class="block-label">被表白男神 ({{bbTongji.nanSum}})</div>
          </div>
        </div>
        <div class="vs">
          <img src="/static/vs.png">
        </div>
        <div class="mai-block">
          <div class="block-item">
            <img src="/static/nv.png">
            <div class="block-label">被表白女神 ({{bbTongji.nvSum}})</div>
          </div>
        </div>
      </div>
      <div class="mai-footer" @click="goto('circleBBList')">
        <div class="nan-line" :style="'width: '+bbNanLineWidth"></div>
        <div class="nv-line" :style="'width: '+bbNvLineWidth"></div>
      </div>

      <biaobai-item :item="bb" :openid="openid" v-if="bb && bb._id"></biaobai-item>
    </div>
    <div class="jiyu-container">
      <block-title title="留言板" link="circleJiyuList" :token="encodeToken"></block-title>
      <jiyu-item v-for="item in jys" :key="item._id" :item="item" :openid="openid"></jiyu-item>
    </div>

    <tab curr="发现" :token="encodeToken"></tab>
  </div>
</template>

<script>
import axios from "axios";
import Tab from "../home/Tab";
import BlockTitle from "../common/BlockTitle";
import MaiItem from "../common/MaiItem";
import BiaobaiItem from "../common/BiaobaiItem";
import JiyuItem from "../common/JiyuItem";
import JingyanItem from "../common/JingyanItem";

export default {
  components: {
    Tab,
    BlockTitle,
    MaiItem,
    BiaobaiItem,
    JiyuItem,
    JingyanItem
  },
  data() {
    return {
      encodeToken: "",
      token: "",
      openid: null,
      sfTongji: {},
      bbTongji: {},
      sfNanLineWidth: "50%",
      sfNvLineWidth: "50%",
      bbNanLineWidth: "50%",
      bbNvLineWidth: "50%",
      sf: {},
      bb: {},
      jys: []
    };
  },
  created() {
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    if (!this.$store.state.User.userInfo._id) {
      axios
        .get("/api/user/wxuserInfo")
        .then(res => {
          if (res.data.success) {
            this.openid = res.data.data.openid;
            this.$store.commit("User/add", res.data.data);
          } else {
            weui.alert("获取用户信息失败");
          }
        })
        .catch(err => {
          weui.alert("获取用户信息失败");
        });
    } else {
      this.openid = this.$store.state.User.userInfo.openid;
    }

    // 获取被卖男女比例
    axios
      .get("/api/circle/sfPercent")
      .then(res => {
        if (res.data.success) {
          this.sfTongji = res.data.data;
          this.sfNanLineWidth = this.sfTongji.nanPercent + "%";
          this.sfNvLineWidth = this.sfTongji.nvPercent + "%";
        } else {
          console.log(res.data.message);
        }
      })
      .catch(err => {
        console.log(err);
      });

    // 获取最新卖队友
    axios
      .get("/api/circle/sfFirst")
      .then(res => {
        if (res.data.success) {
          this.sf = res.data.data;
        } else {
          console.log(res.data.message);
        }
      })
      .catch(err => {
        console.log(err);
      });

    // 获取被表白男女比例
    axios
      .get("/api/circle/bbPercent")
      .then(res => {
        if (res.data.success) {
          this.bbTongji = res.data.data;
          this.bbNanLineWidth = this.bbTongji.nanPercent + "%";
          this.bbNvLineWidth = this.bbTongji.nvPercent + "%";
        } else {
          console.log(res.data.message);
        }
      })
      .catch(err => {
        console.log(err);
      });

    // 获取最新表白墙
    axios
      .get("/api/circle/bbFirst")
      .then(res => {
        if (res.data.success) {
          this.bb = res.data.data;
        } else {
          console.log(res.data.message);
        }
      })
      .catch(err => {
        console.log(err);
      });
    
    // 获取最新3个留言
    axios
      .get("/api/circle/jyThree")
      .then(res => {
        if (res.data.success) {
          this.jys = res.data.data;
        } else {
          console.log(res.data.message);
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    goto(link) {
      this.$router.push("/" + link + "/" + this.encodeToken);
    }
  }
};
</script>

<style scoped>
.container {
  margin-bottom: 60px;
}
.tab-banner {
  display: flex;
  padding-top: 15px;
  padding-bottom: 5px;
}
.banner-item {
  flex: 1;
  text-align: center;
}
.banner-item img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
.banner-label {
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 5px;
}
.huo {
  color: red;
  position: absolute;
  margin-left: 10px;
  font-size: 24px;
}
.mai-top {
  display: flex;
  width: 100%;
  margin-top: 10px;
}
.mai-block {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mai-block img {
  width: 45px;
  height: 45px;
}
.vs {
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.vs img {
  width: 60px;
}
.block-label {
  text-align: center;
  margin-top: 5px;
}
.block-item {
  text-align: center;
}
.mai-footer {
  display: flex;
  margin-top: 5px;
}
.nan-line {
  border-bottom: 2px solid #1296db;
}
.nv-line {
  border-bottom: 2px solid #ff9db3;
}
</style>





// WEBPACK FOOTER //
// src/components/infos/CircleDiscovery.vue